module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": "Dashboard"
    }
  })], 1), _vm._v(" "), (_vm.user) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('dashboard.welcome')) + " " + _vm._s(_vm.user.name))])])], 1), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.registration) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationName')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.name))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationAddress')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.address))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationApprovedDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.registration.registrationDate)))])])], 1)], 1), _vm._v(" "), _c('b-row', [(_vm.isPublicEntity) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationBudgetId')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.companyNumber))])])], 1) : _vm._e(), _vm._v(" "), (_vm.isPrivateEntity) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationCompanyNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.companyNumber))])])], 1) : _vm._e(), _vm._v(" "), (_vm.isPrivateEntity) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationTaxIdNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.taxIdNumber))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [(_vm.registration.invoiceLimit) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('dashboard.liabilitiesRegistrationLimit')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.invoiceLimit))])])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.liabilitiesTotal && !_vm.isAdmin) ? _c('div', [_c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('dashboard.liabilitiesRegisteredTotal')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.liabilitiesTotal.debtorInvoices + _vm.liabilitiesTotal.creditorInvoices))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('dashboard.liabilitiesRegisteredDebtor')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.liabilitiesTotal.debtorInvoices))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('dashboard.liabilitiesRegisteredCreditor')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.liabilitiesTotal.creditorInvoices))])])], 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a03f095e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/dashboard/Dashboard.vue
// module id = 779
// module chunks = 1